// extracted by mini-css-extract-plugin
export default {"containerTimer":"timer__containerTimer___LS1ch","settingIcon":"timer__settingIcon___K3Vx1","autoUpdateTitle":"timer__autoUpdateTitle___zvmsY","timer":"timer__timer___CaYKf"};